import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import CloseIcon from '../../resources/Close.svg';
import { RedButton, WhiteButton } from '../../components/Button';

interface Props {
	handleModal: any;
	closeModal: any;
}

const SalesTotalModal = ({ handleModal, closeModal }: Props) => {
	const containerRef = React.useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
				closeModal();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [closeModal]);

	return (
		<>
			<StyledModal>
				<Container ref={containerRef}>
					<UpperContainer>
						<StyledCloseButton src={CloseIcon} onClick={closeModal} />
					</UpperContainer>
					<LowerContainer>
						<StyledHeading>
							{'Are you sure you want to submit your totals?'}
							<br />
							<br />
							{"If you proceed, you won't be able to process additional sales for this Book Fair in the Payment Portal."}
						</StyledHeading>
						<StyledButtonContainer>
							<StyledRedButton handleClick={handleModal}>Submit</StyledRedButton>
							<StyledWhiteButton handleClick={closeModal}>
								<p>Cancel</p>
							</StyledWhiteButton>
						</StyledButtonContainer>
					</LowerContainer>
				</Container>
			</StyledModal>
		</>
	);
};

const StyledModal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2000;
`;

const Container = styled.div`
	display: flex;
	position: fixed;
	top: 30px;
	left: 50%;
	transform: translateX(-50%);
	width: 600px;
	height: fit-content;
	padding: 16px 16px 20px 16px;
	flex-direction: column;
	align-items: center;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0px 7px 14px 0px rgba(0, 0, 0, 0.2);
	@media (max-width: 700px) {
		width: calc(100% - 80px);
	}
`;

const UpperContainer = styled.div`
	display: flex;
	padding-bottom: 20px;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;
`;

const LowerContainer = styled.div`
	display: flex;
	width: 568px;
	padding: 8px 0px 24px 0px;
	flex-direction: column;
	align-items: center;
	gap: 60px;
	@media (max-width: 440px) {
		gap: 40px;
	}
`;

const StyledHeading = styled.p`
	color: #333333;
	text-align: left;
	font-size: 21px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	width: 339px;
	margin: 0;
	@media (max-width: 440px) {
		font-size: 18px;
		width: 280px;
	}
`;

const StyledCloseButton = styled.img`
	position: absolute;
	right: 16px;
	top: 16px;
	background: none;
	border: none;
	cursor: pointer;
	height: 16px;
	width: 16px;
`;

const StyledButtonContainer = styled.div`
	display: flex;
	width: 280px;
	justify-content: center;
	align-items: center;
	gap: 32px;
	height: 40px;
	@media (max-width: 440px) {
		gap: 10px;
	}
`;

const StyledWhiteButton = styled(WhiteButton)`
	min-width: 91px;
	width: 91px;
	p {
		color: #333333;
		&:hover {
			color: #919191;
		}
		&:active {
			color: #919191;
		}
	}
`;

const StyledRedButton = styled(RedButton)`
	width: 157px;
`;

export default SalesTotalModal;
